<template>
  <div>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item label="日期">
        <el-date-picker
          v-model="currentDate"
          value-format="yyyy-MM-dd"
          type="date"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getData()">搜尋</el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-if="tableData && tableData['資料']"
      :data="tableData['資料']"
      border
      style="margin-top:18px"
    >
      <af-table-column
        v-for="key in Object.keys(tableData['資料'][0])"
        :key="key"
        header-align="center"
        align="center"
        :prop="key"
        :label="key"
        width="275px"
      >
      </af-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchData: {},
      currentDate: "",
      tableData: false
    };
  },
  methods: {
    getData() {
      this.$http
        .get(`/back/admin/check_balance`, {
          params: { date: this.currentDate }
        })
        .then(res => {
          if (res.data.code == 0) {
            this.tableData = res.data.data;
          }
        });
    }
  },
  created() {}
};
</script>
